import { ReactNode } from "react";
import { BlockCard, MetricTile } from "../primitives";
import { BlockBaseProps, Delta } from "../types";
import AccountInfoBlockSkeleton from "./Skeleton";
import styles from "./style.module.scss";

export interface AccountMetric {
  key: string;
  label: string;
  value: string | number;
  /** Baseline caption, e.g. "trials" or "2 expired · 1 overdue". */
  unit?: string;
  icon?: ReactNode;
  delta?: Delta;
}

interface AccountInfoBlockProps extends BlockBaseProps {
  metrics: AccountMetric[];
  title?: string;
  /** Placeholder count while loading; keep it equal to the real metric count. */
  skeletonCount?: number;
}

/** Account mix across the estate: demo, premium, expired, expiring and test. */
function AccountInfoBlock({
  metrics,
  title = "Account information",
  loading,
  empty,
  skeletonCount = 6,
  className,
}: AccountInfoBlockProps) {
  if (loading) {
    return (
      <AccountInfoBlockSkeleton count={skeletonCount} className={className} />
    );
  }

  return (
    <BlockCard title={title} compactTitle empty={empty} className={className}>
      <div className={styles.grid}>
        {metrics.map((metric) => (
          <MetricTile
            key={metric.key}
            label={metric.label}
            icon={metric.icon}
            value={metric.value}
            unit={metric.unit}
            delta={metric.delta}
          />
        ))}
      </div>
    </BlockCard>
  );
}

export default AccountInfoBlock;
